export const TABS = {
    ALL: 'ALL',
    SYSTEM: 'SYSTEM',
    INTERESTS: 'INTERESTS',
    LANGUAGE: 'LANGUAGE',
    ROLES: 'ROLES',
}
